import { z } from "zod";
import { IdempotencyKeySchema, IdSchema, IsoDateTimeSchema, Sha256Schema } from "./primitives.js";
/**
 * Addenda to a signed encounter note (EXECDEV-55, migration 20261012235814). A physician adds a
 * dated, signed entry below a note that is already signed; the note itself never changes. Each
 * addendum is signed when it is saved and cannot be edited or removed afterwards. The encounter
 * keeps its status and version, so the OHIP claim and anything else bound to the signed note stay
 * as they are.
 */
export const NOTE_ADDENDUM_MAX_CHARS = 10_000;
export const EncounterNoteAddendumSchema = z
    .object({
    addendumId: IdSchema,
    encounterId: IdSchema,
    /** The signed note version this addendum follows. */
    noteId: IdSchema,
    noteVersion: z.number().int().positive(),
    /** 1 for the encounter's first addendum, then 2, 3, … */
    sequence: z.number().int().positive(),
    text: z.string().min(1).max(NOTE_ADDENDUM_MAX_CHARS),
    signedAt: IsoDateTimeSchema,
    signedBy: IdSchema,
    /** The signer's display name; absent when the account has none. */
    signer: z.string().min(1).optional(),
    contentHash: Sha256Schema,
})
    .strict();
/** GET /v1/encounters/:encounterId/note-addenda: oldest first. */
export const EncounterNoteAddendaSchema = z
    .object({
    encounterId: IdSchema,
    items: z.array(EncounterNoteAddendumSchema),
})
    .strict();
export const SignEncounterNoteAddendumRequestSchema = z
    .object({
    /** One key per addendum the physician means to sign; a retry reuses it and never signs twice. */
    idempotencyKey: IdempotencyKeySchema,
    /** Surrounding whitespace is trimmed before signing; nothing else is changed. */
    text: z.string().trim().min(1).max(NOTE_ADDENDUM_MAX_CHARS),
})
    .strict();
/** POST /v1/encounters/:encounterId/note-addenda: `created` is false for a retried key. */
export const SignEncounterNoteAddendumReceiptSchema = z
    .object({
    created: z.boolean(),
    addendum: EncounterNoteAddendumSchema,
})
    .strict();
//# sourceMappingURL=note-addenda.js.map